import {
    DeviceStatus,
    DeviceStatusTagClassName,
    DeviceStatusValue,
    RealDevice,
    SensorStatus
} from "dto/realdevice/devices"
import {observer} from "mobx-react"
import {useRootStore} from "store/useRootStore"
import dayjs from "dayjs"
import {RepresentationImage} from "pages/dashboard/wheelchair/RepresentationImage"
import styled from "styled-components"

interface WheelchairListItemProps {
    devices: RealDevice[]
}

export const WheelchairListItems = observer(({devices}: WheelchairListItemProps) => {
    const {
        dashboardStore: {
            selectedDevice,
            selectDevice,
            setShowSelectedRealDeviceInfo,
            setShowPathTrackingInfo,
            setShowImpactHistory
        }
    } = useRootStore()

    return (
        <>
            {devices.map(device => {
                const selected = selectedDevice?.id === device.id
                const {imageFile, imageFiles} = device
                // const imgSrc = imageFile ? `${staticResourceUrl}/${imageFile?.name}` : "img/i-img.png"
                const lastCommunicationTime = device.communicationDevice?.lastCommunicationTime ?
                    dayjs(device.communicationDevice?.lastCommunicationTime).format("YYYY/MM/DD HH:mm:ss") : "----/--/-- --:--:--"

                const sensorStatus = device.communicationDevice.sensorStatus || {} as SensorStatus

                return (
                    <div className={`main-box is-clickable ${selected ? "active" : ""}`} key={device.id}
                         onClick={(e) => {
                             selectDevice(device)
                         }}>
                        <div className="main-box-toolbar">
                            <StatusTag stat={device.communicationDevice.status} sensorStatus={sensorStatus}/>
                        </div>
                        <div className="columns  is-gapless ml5 ">
                            {/*<div className="column is-one-quarter">*/}
                            <div>
                                {/*<img src={imgSrc} alt="" width={140} style={{maxHeight: 160}}/>*/}
                                <RepresentationImage images={imageFiles}/>
                            </div>
                            <div className="column ml10" style={{marginLeft: 10}}>
                                <div className="is-size-4 mt10">
                                    {device.name}
                                    {/*<br/>({device.communicationDevice.eui})*/}
                                </div>
                                <div className="mt5">
                                    <span className=""><i className="fa fa-map-marker-alt"/></span><span
                                    className="ml10">
                                    {device.address?.address + device.address?.subAddress || "주소 지정 안됨"}
                                </span>
                                </div>
                                <div>위도 :{device.communicationDevice?.currentLatLng?.lat || "----"}
                                    / 경도 : {device.communicationDevice?.currentLatLng?.lng || "----"}</div>
                                <div>
                                    <span className="is-size-6">최근통신 : {lastCommunicationTime}</span>
                                </div>
                                <div className="mt10">
                                    <button className="button is-tr-blue is-rounded is-small mt5"
                                            onClick={(e) => {
                                                setShowSelectedRealDeviceInfo(true)
                                                // e.preventDefault()
                                                // e.stopPropagation()
                                            }}>정보확인
                                    </button>
                                    <button className="button is-tr-green is-rounded is-small mt5 ml-2"
                                            onClick={(e) => {
                                                setShowPathTrackingInfo(true)
                                                // e.preventDefault()
                                                // e.stopPropagation()
                                            }}>경로추적
                                    </button>
                                    <button className="button is-tr-orange is-rounded is-small mt5 ml-2"
                                            onClick={(e) => {
                                                // e.preventDefault()
                                                // e.stopPropagation()
                                                setShowImpactHistory(true)
                                            }}>넘어짐감지
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="columns  is-gapless ml5 ">
                            <SensorStatusTag sensorStatus={sensorStatus}/>
                        </div>

                    </div>
                )
            })}

        </>
    )
})

export const SensorStatusTag = ({sensorStatus}: {sensorStatus: SensorStatus}) => {
    return (
        <>
            <CircleTag label="비정상움직임" on={sensorStatus.abnormal}/>
            <CircleTag label="리셋됨" on={sensorStatus.reset}/>
            {/*<CircleTag label="배터리이상" on={sensorStatus.batteryCheck}/>*/}
            <CircleTag label="운행종료" on={sensorStatus.powerOff}/>
            <CircleTag label="운행중" on={sensorStatus.moving}/>
            <CircleTag label="넘어짐" on={sensorStatus.fall}/>
            <CircleTag label="전원분리" on={sensorStatus.powerDisconnected}/>
        </>
    )
}

export const StatusTag = ({stat, sensorStatus, isSmall = false}: { stat: DeviceStatus | null | undefined, sensorStatus: SensorStatus, isSmall?: boolean }) => {
    const tagSize = isSmall ? "" : "is-size-6"
    if(sensorStatus.powerOff) {
        return (
            <span
                className={`tag ${tagSize} is-warning`}>운행종료</span>
        )
    }
    return (
        <span
            className={`tag ${tagSize} ${DeviceStatusTagClassName[stat || "STAND_BY"]}`}>{stat ? DeviceStatusValue[stat] : "-"}</span>
    )
}

export const CircleTag = ({label, on}: { label: string, on: boolean }) => {
    return (
        <>
            <Circle color={on ? "hsl(348, 100%, 61%)" : "#00d3d3"}/>
            <span style={{fontSize: 8, }}>{label}</span>
        </>
    )

}

const Circle = styled.div`
  width: 10px;
  height: 10px;
  margin-left: 5px;
  margin-top: 1px;
  margin-right: 2px;
  border-radius: 50%;
  background-color: ${props => props.color};
`
